export default {"src":"/_next/static/media/configurator-icon.9a489cd9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};